
const KEY = {
    CurrentWarehouse: 'EKnown.CurrentWarehouse',
    CurrentProject: 'EKnown.CurrentProject',
    CurrentBU: 'EKnown.CurrentBU',
    CurrentApp: 'EKnown.CurrentApp',
    UserInfo: 'EKnown.UserInfo',
    Collapsed: 'EKnown.Collapsed'
}

const CurrentWarehouse: any = () => getStorage(KEY.CurrentWarehouse);
const CurrentProject: any = () => getStorage(KEY.CurrentProject);
const CurrentBU: any = () => getStorage(KEY.CurrentBU);
const CurrentApp: any = () => getStorage(KEY.CurrentApp);
const UserInfo: any = () => getStorage(KEY.UserInfo);

const getStorage = (key: string) => {
    var value = null;
    var item = localStorage.getItem(key)
    if (item) {
        value = JSON.parse(item);
    };
    return value;
}
const setStorage = (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value))
}
export default {
    KEY,
    getStorage,
    setStorage,
    CurrentWarehouse,
    CurrentProject,
    CurrentBU,
    CurrentApp,
    UserInfo,
}